import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PARAGRAPH_PROGRESS_FEATURE_KEY,
  ParagraphProgressState,
  paragraphProgressAdapter,
} from './paragraph-progress.reducer';
import { selectRouteParams } from '@lyceo/shared/data-access';

export const selectParagraphProgressState =
  createFeatureSelector<ParagraphProgressState>(PARAGRAPH_PROGRESS_FEATURE_KEY);

const { selectAll } = paragraphProgressAdapter.getSelectors();

export const selectAllParagraphProgresses = createSelector(
  selectParagraphProgressState,
  (state: ParagraphProgressState) => selectAll(state),
);

export const selectParamParagraphProgress = createSelector(
  selectAllParagraphProgresses,
  selectRouteParams,
  (paragraphProgresses, { paragraphId }) =>
    paragraphProgresses.find(
      (paragraphProgress) => paragraphProgress.paragraphId === paragraphId,
    ),
);

export const selectParamParagraphProgressSeenVideos = createSelector(
  selectParamParagraphProgress,
  (paragraphProgresses) =>
    paragraphProgresses ? paragraphProgresses.seenVideos : [],
);
